(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@emotion/core"), require("prop-types"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define("NetlifyCmsUiDefault", ["@emotion/core", "prop-types", "react"], factory);
	else if(typeof exports === 'object')
		exports["NetlifyCmsUiDefault"] = factory(require("@emotion/core"), require("prop-types"), require("react"));
	else
		root["NetlifyCmsUiDefault"] = factory(root["NetlifyCmsDefaultExports"]["EmotionCore"], root["NetlifyCmsDefaultExports"]["PropTypes"], root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 